export const VEHICLE_ENUM_ROUTE_PREFIX = "/settings/vehicle-enums";

export const VEHICLE_ENUM_ROUTE_PATHS = {
  list: { path: "*", to: VEHICLE_ENUM_ROUTE_PREFIX },
};
